import { Settings } from 'luxon';
import { localeInitialState } from '../features/locale/localeSlice';

/**
 * Set default locale for all luxon instances
 * */
Settings.defaultLocale = localeInitialState.lang;
